import { aiInRecruitingIndustrySectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingIndustrySection.module.css'

const AiInRecruitingIndustrySection = () => {
  const { title, subtitle, items } = aiInRecruitingIndustrySectionData
  return (
    <section className={`${styles.whySection}`}>
      <div className="container">
        <div className={styles.whyTitleHeader}>
          <h2 className={styles.whyTitle}>{title}</h2>
          <p className={styles.whySubtitle}>{subtitle}</p>
        </div>

        <div className={styles.listWrapper}>
          {items.map((item, i) => (
            <div key={i} className={styles.listItem}>
              <div className={styles.itemIcon}>{item.icon}</div>
              <div className={styles.itemTitle}>{item.title}</div>
              <div className={styles.itemDesc}>{item.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingIndustrySection
